'use client';

import { TYPE_FILTER_OPTIONS, type TypeFilter } from './materialCatalogFilters';

export type MaterialCatalogToolbarProps = {
  search: string;
  type: TypeFilter;
  totalCount: number;
  filteredCount: number;
  onSearchChange: (value: string) => void;
  onTypeChange: (value: TypeFilter) => void;
  onReset: () => void;
};

export function MaterialCatalogToolbar({
  search,
  type,
  totalCount,
  filteredCount,
  onSearchChange,
  onTypeChange,
  onReset,
}: MaterialCatalogToolbarProps) {
  const filtered = search.trim().length > 0 || type !== 'all';

  return (
    <div className="material-catalog-toolbar">
      <label className="material-catalog-toolbar__search">
        <span className="visually-hidden">Search materials</span>
        <input
          type="search"
          placeholder="Search by name, formula, or synonym…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="material-catalog-toolbar__input"
        />
      </label>
      <label className="material-catalog-toolbar__type">
        <span className="visually-hidden">Material type</span>
        <select
          value={type}
          onChange={(e) => onTypeChange(e.target.value as TypeFilter)}
          className="material-catalog-toolbar__select"
        >
          {TYPE_FILTER_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      {filtered ? (
        <button type="button" className="material-catalog-toolbar__reset btn btn--ghost" onClick={onReset}>
          Reset filters
        </button>
      ) : null}
      <p className="material-catalog-toolbar__count text-muted">
        Showing {filteredCount} of {totalCount} materials
      </p>
    </div>
  );
}
